import { NavLink } from 'react-router-dom';
import { Wallet, Flag, Scale, BookOpen, Settings as SettingsIcon, CalendarClock } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

// ----------------------------------------------------------------
// ChipBankTabs
// ----------------------------------------------------------------
// Sub-navigation for the Player Accounts pages (the player-facing side of
// the cage: bank, credit, disputes, reconciliation, ledger, settings).
// The Cage Balancing (CBS) suite lives in its own area now — see
// CageBalancingTabs. Each tab is gated by permission / admin; an empty
// list renders nothing.

const PLAYER_ACCOUNTS = [
  { to: '/cage', label: 'Cage', icon: Wallet },
  { to: '/credit-aging', label: 'Credit Aging', icon: CalendarClock, perm: 'credit:view' },
  { to: '/disputes', label: 'Disputes', icon: Flag },
  { to: '/reconciliation', label: 'Reconciliation', icon: Scale, adminOnly: true },
  { to: '/ledger', label: 'Ledger', icon: BookOpen, adminOnly: true },
  { to: '/player-bank-settings', label: 'Settings', icon: SettingsIcon, adminOnly: true },
];

export default function ChipBankTabs() {
  const { isAdmin, can } = useAuth();

  const tabs = PLAYER_ACCOUNTS.filter((t) => {
    if (t.adminOnly && !isAdmin) return false;
    if (t.perm && !can(t.perm)) return false;
    return true;
  });
  if (tabs.length === 0) return null;

  return (
    <div className="-mt-2 mb-4 flex flex-wrap gap-1 border-b border-gray-700">
      {tabs.map((t) => {
        const Icon = t.icon;
        return (
          <NavLink
            key={t.to}
            to={t.to}
            className={({ isActive }) =>
              `flex items-center gap-2 px-4 py-2.5 text-sm font-medium border-b-2 transition-colors ${
                isActive
                  ? 'border-amber-500 text-amber-400'
                  : 'border-transparent text-gray-400 hover:text-gray-200 hover:border-gray-600'
              }`
            }
          >
            <Icon size={16} />
            {t.label}
          </NavLink>
        );
      })}
    </div>
  );
}
